import React from 'react';
import moment from 'moment';
import {useStakingContract} from "context/StakingContract";
import StakingContract from "context/StakingContract/StakingContract";


const TopInfo = () => {
  const {state, stakingContract} = useStakingContract();
  const {prerequisites} = state;
  const [withdrawDate, setInitWithdrawDate] = React.useState('0');
  const [stakedAmount, setStakedAmount] = React.useState('0');


  React.useEffect(()=>{
    if (StakingContract.hasMetamask()) {
        stakingContract.getStakeDeposit()
        .then(res => {
          setStakedAmount(res[0].toString());
          setInitWithdrawDate(res[2].toString());
      }).catch(err => {
        console.warn("error get stake deposit", err);
      });
    }
  }, []);

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="item row">
          <div className="key col-md-3">Your address</div>
          <div className="value col-md-9">{prerequisites.connectedAddress}</div>
        </div>
        <div className="item row">
          <div className="key col-md-3">Contract address</div>
          <div className="value col-md-9">{StakingContract.getEnv("REACT_APP_ETH_DEPLOYED_CONTRACT")}</div>
        </div>
        {withdrawDate !== '0' && stakedAmount !== '0' && (
          <div className="item row">
            <div className="key col-md-3">Withdraw initialized</div>
            <div className="value col-md-9">{moment.unix(withdrawDate).format("Do of MMMM HH:mm")} UTC</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopInfo;